import PriceFormatter from 'features/shared/components/formatters/PriceFormatter';
import { Currency } from 'features/shared/enums/currency';
import React from 'react';
import { useTranslation } from 'react-i18next';
import InvoiceRecapitulationDTO from '../dtos/InvoiceRecapitulationDTO';
import { InvoiceRecapitulationType } from '../enums/invoiceRecapitulationType';
import styles from './invoicerecapitulationitem.module.scss';

interface Props {
  recapitulationItem: InvoiceRecapitulationDTO;
  currency: Currency;
}

const InvoiceRecapitulationItem = ({ recapitulationItem, currency }: Props) => {
  // translation
  const { t } = useTranslation(["invoice\\enums\\invoiceRecapitulationType"]);

  // sub-renders
  const renderTaxableAmount = () => {
    if (recapitulationItem.taxableAmount && recapitulationItem.invoiceRecapitulationType == InvoiceRecapitulationType.InvoiceLinesTotal) {
      return (
        <span className={`mr-sm-4 order-1 order-sm-0 ${styles.taxablePrice}`}>
          <PriceFormatter amount={recapitulationItem.taxableAmount} currency={currency} decimalPlaces={2} />
        </span>
      );
    }
  }

  // render
  return (
    <div className="d-flex justify-content-between mb-1 px-sm-2">
      <span className="text-muted">{t(recapitulationItem.invoiceRecapitulationType || "")}</span>
      <div className="d-flex flex-column flex-sm-row text-right">
        {renderTaxableAmount()}
        <span className={styles.price}>
          <PriceFormatter amount={recapitulationItem.taxInclusiveAmount!} currency={currency} decimalPlaces={2} />
        </span>
      </div>
    </div>
  )
}

export default InvoiceRecapitulationItem;
